import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FeildActivity_Interface,Empty_FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FeildActivityService } from 'src/app/Service/FeildActivity/FeildActivity.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-FeildActiviryAdd',
  templateUrl: './FeildActiviryAdd.component.html',
  styleUrls: ['./FeildActiviryAdd.component.scss']
})
export class FeildActiviryAddComponent implements OnInit {

  constructor(
    private FeildActivity_Service:FeildActivityService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.AddNewFeildActivity=new FormGroup({
      id :new FormControl(),

      Title:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(17).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewFeildActivity:FormGroup;


  get_Form_Title(){
    return this.AddNewFeildActivity.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewFeildActivity(){
    var Record:FeildActivity_Interface =Empty_FeildActivity_Interface()
    Record.id=0
    Record.code=""
    Record.title=this.get_Form_Title().value
    this.InProccessing=true
    this.FeildActivity_Service.AddFeildActivity(Record).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("زمینه فعالیت وارد شده ، در لیست وجود دارد")
        }
        else{
          this.AddNewFeildActivity.reset()
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }



}
